import React from 'react';
import { Redirect } from 'react-router-dom';

import { facilityURL } from '@admin/config/routes';

export const LinkedFacilityRedirect: React.FC<{ facilityID: string }> = ({ facilityID }) => {
  return <Redirect to={facilityURL({ id: facilityID })} />;
};
